module.exports = __webpack_public_path__ + "static/img/boy.7ba345ed.png";